(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document.querySelectorAll('[data-sphatik-reveal]').forEach(function (el) {
      el.classList.add('sphatik-reveal--visible');
    });
  }

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('sphatik-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  function observeAll() {
    document.querySelectorAll('[data-sphatik-reveal]:not(.sphatik-reveal--visible)').forEach(function (el) {
      observer.observe(el);
    });
  }

  observeAll();

  document.addEventListener('shopify:section:load', observeAll);
})();
